<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;" @click="$router.back()">专题管理</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">专题报名列表</a>
        </span>
      </div>
      <div class="framePage-body">
        <el-tabs v-model="activeName" :before-leave="beforeTabLeave" @tab-click="tabChange">
          <el-tab-pane label="按课程报名" name="first" >
            <specialCourseRegistration ref="first"  />
          </el-tab-pane>
          <el-tab-pane label="按机构报名" name="second">
            <specialInstitutionRegistration ref="second"  />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import specialCourseRegistration from "@/views/miniApp/thematicManagement/specialCourseRegistration.vue";
import specialInstitutionRegistration from "@/views/miniApp/thematicManagement/specialInstitutionRegistration.vue";
export default {
  name: "addCourseBox",
  components: {
    specialCourseRegistration,
    specialInstitutionRegistration
  },
  mixins: [List],
  data() {
    return {
      projectCourseId:this.$route.query.projectCourseId,
      activeName: "first",
      projectName: '',
      courseId:'',
    };
  },
  methods: {
    
    init() {
      this.projectName = sessionStorage.getItem("projectName");
      const query = this.$route.query;
      if (query.active) {
        this.activeName = query.active;
      } else {
        this.activeName = "first";
      }
    },
    getId(data) {
      this.courseId = data
      console.log(this.courseId);
    },
    beforeTabLeave(newName) {
      this.$router.replace({path:this.$route.path, query:{active:newName}});
    },
    tabChange(e) {
      this.$refs[e.name].getData(-1);
      if(this.courseId) {
        this.$refs[e.name].getDetail(this.courseId);
        this.$refs[e.name].rowId = this.courseId;
      }
      
    }
  }
};
</script>
<style lang="less"></style>
